// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"YU","skip_info":"ZU","skipped":"aV","modify_order":"bV","cancel_subscription_btn":"cV","byb":"eV","modify_order_outer":"fV","byb_edit_btn":"gV","modify_order_item":"hV","cancel_copy_wrapper":"iV","cancelled_copy":"jV"};
    if(module.hot) {
      // 1715091683263
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  